import api, { ResponseCallback } from '../services/api.service'

export type AddonName = 
  'extendInventoryCreateFormWhenItemEquals' |
  'extendInventoryCreateFormWithQuantityOnCase' |
  'extendInventoryCreateFormWithActualWeight' |
  'extendPackTraceCreateFormWithPallet' |
  'changePalletCode' |
  'changeCaseCode' |
  'extendInventoryCreateFormWhenCategoryNameEquals'

export interface AddonData {
  id: number
  name: AddonName
}

const routes = {
  list: '/addons'
}

export default {
  list (callback: ResponseCallback<AddonData[]>) {
    api.get(routes.list, {}, callback)
  }
}
